import React from "react";

export default function PaymentPolicy() {
  return (
    <div className="container py-5">

      <h1 className="fw-bold mb-4">Payment & Billing Policy</h1>

      <p className="text-muted" style={{ fontSize: "16px" }}>
        This Payment & Billing Policy outlines how payments, billing, invoicing, refunds,
        and charge disputes are handled by <strong>SWIFTSHIP</strong>.  
        By using our logistics, freight, warehousing, or fulfillment services, you agree to
        the terms stated below.
      </p>

      <hr className="my-4" />

      {/* SECTION 1 */}
      <h3 className="fw-bold">1. Accepted Payment Methods</h3>

      <p className="text-muted">
        SWIFTSHIP accepts secure payments through trusted third-party processors. We currently accept:
      </p>

      <ul className="text-muted">
        <li>✔ Visa, Mastercard, American Express, Discover</li>
        <li>✔ Debit Cards</li>
        <li>✔ ACH / Bank Transfers (for approved accounts)</li>
        <li>✔ Corporate / Business Payments & Invoicing</li>
      </ul>

      <p className="text-muted">
        All payments are processed securely through PCI-DSS compliant partners.  
        <strong>We do not store or have access to your full card details.</strong>
      </p>

      <hr className="my-4" />

      {/* SECTION 2 */}
      <h3 className="fw-bold">2. Billing & Invoices</h3>

      <p className="text-muted">
        Customers will receive digital invoices for all logistics services. Invoices must be paid:
      </p>

      <ul className="text-muted">
        <li>✔ Before shipment pickup or dispatch</li>
        <li>✔ Immediately for same-day or urgent shipments</li>
        <li>✔ Within agreed terms for corporate clients</li>
      </ul>

      <p className="text-muted">
        Unpaid invoices may result in delays, storage fees, or suspension of services.
      </p>

      <hr className="my-4" />

      {/* SECTION 3 */}
      <h3 className="fw-bold">3. Service Charges & Additional Fees</h3>

      <p className="text-muted">
        Depending on the shipment type, additional fees may apply for:
      </p>

      <ul className="text-muted">
        <li>✔ Customs duties & taxes (international shipments)</li>
        <li>✔ Address correction or re-routing charges</li>
        <li>✔ Storage, handling, and warehouse holding fees</li>
        <li>✔ Return shipments due to non-delivery or incomplete address</li>
        <li>✔ Oversized or overweight package fees</li>
      </ul>

      <p className="text-muted">
        Customers are responsible for any third-party carrier fees or government levies.
      </p>

      <hr className="my-4" />

      {/* SECTION 4 */}
      <h3 className="fw-bold">4. Non-Refundable Service Conditions</h3>

      <p className="text-muted">
        Certain logistics and freight-related fees become non-refundable once processing begins.
        Customers agree that:
      </p>

      <ul className="text-muted">
        <li>✔ Once a shipment label or booking is generated, fees cannot be refunded</li>
        <li>✔ Delays within the disclosed timeframe (30–45 days or longer) do not qualify for refunds</li>
        <li>✔ Completed or in-transit shipments cannot be cancelled</li>
        <li>✔ International customs delays are not refundable events</li>
      </ul>

      <p className="text-muted">
        These conditions protect the integrity of the shipping process and comply with carrier rules.
      </p>

      <hr className="my-4" />

      {/* SECTION 5 */}
      <h3 className="fw-bold">5. Chargeback Prevention & Dispute Handling</h3>

      <p className="text-muted">
        Customers agree to contact SWIFTSHIP support **before initiating any chargeback**.
        We maintain:
      </p>

      <ul className="text-muted">
        <li>✔ Proof of shipment, tracking history, carrier scans</li>
        <li>✔ Customer communication logs</li>
        <li>✔ Delivery records and documentation</li>
        <li>✔ Signed agreements and verification steps</li>
      </ul>

      <p className="text-muted">
        Filing unwarranted, fraudulent, or bad-faith chargebacks may result in:
      </p>

      <ul className="text-muted">
        <li>✔ Account suspension</li>
        <li>✔ Shipment hold or cancellation</li>
        <li>✔ Legal cost recovery</li>
        <li>✔ Reporting to payment networks</li>
      </ul>

      <p className="text-muted">
        Disputes are processed transparently using factual shipping data and carrier logs.
      </p>

      <hr className="my-4" />

      {/* SECTION 6 */}
      <h3 className="fw-bold">6. Fraud Screening & Verification</h3>

      <p className="text-muted">
        To protect our customers and reduce fraudulent transactions, SWIFTSHIP may require:
      </p>

      <ul className="text-muted">
        <li>✔ Identity verification (ID, business documents, EIN)</li>
        <li>✔ Address confirmation for pickup/delivery</li>
        <li>✔ Additional validation for high-value shipments</li>
        <li>✔ Manual review for suspicious or mismatched billing details</li>
      </ul>

      <p className="text-muted">
        Orders flagged by fraud detection systems may experience temporary holds.
      </p>

      <hr className="my-4" />

      {/* SECTION 7 */}
      <h3 className="fw-bold">7. Delivery Timeframe Acknowledgment</h3>

      <p className="text-muted">
        Customers acknowledge that logistics delivery timelines may require:
      </p>

      <ul className="text-muted">
        <li><strong>✔ 30–45 days or longer</strong> for international or consolidated freight</li>
        <li>✔ 7–14 days for domestic logistics</li>
      </ul>

      <p className="text-muted">
        These timelines do <strong>not</strong> qualify as grounds for a refund or chargeback since they are
        disclosed prior to service use.
      </p>

      <hr className="my-4" />

      {/* SECTION 8 */}
      <h3 className="fw-bold">8. Contact Information</h3>

      <p className="text-muted">
        For billing, payment questions, or dispute assistance, contact us at:
      </p>

      <p className="mt-2">
        <strong>Email:</strong> info@swiftship.us <br />
        <strong>Address:</strong> 3800 Cabell Dr, Irving, TX 75063, United States <br />
        <strong>Phone:</strong> (480) 520-0274
      </p>

    </div>
  );
}
